import { Injectable } from '@angular/core';

import { UserApi } from '../api/user-api';
@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private readonly userApi: UserApi) { }

    async verifyAccount(emailAddress) {

        const queryArgs = `email:"${emailAddress}"`;
        const users = await this.userApi.queryUsers(queryArgs);
        if (users && Array.isArray(users) && users.length > 0) {
            return users[0];
        } else {
            // TODO: retrieve pdauth user info and create new user
            return null;
        }

    }

    async searchUsers(searchText: string, max?: number, includeADGroups?: boolean, publicData?: boolean) {

        const users = await this.userApi.searchUsers(searchText, max, publicData);

        if (includeADGroups) {
            // TODO: include active directory users
        }

        return users;
    }

    async registerUser(email: string) {
        return await this.userApi.registerUser(email);
    }
}
